export class Channels {
    channelName: string;
    lowCp: number;
    highCp: number;
    colPosition: number;
}

export class RuleSet {
    channelValues: string[];
    channelResult: string;
}

export class ResultSet {
    rule: string;
    result: string;
}